const Products = () => {
  return (
    <section className="relative min-h-screen overflow-hidden bg-gradient-to-br from-slate-50 via-white to-cyan-50 py-20">

      {/* Background Blobs */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-cyan-200/30 blur-3xl rounded-full"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-blue-200/30 blur-3xl rounded-full"></div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">

        {/* Header */}
        <div className="text-center mb-16">

          <span className="inline-flex items-center px-4 py-2 rounded-full bg-cyan-100 text-cyan-700 text-sm font-semibold mb-5">
            🚀 Launching Soon
          </span>

          <h1 className="text-5xl md:text-6xl font-extrabold text-slate-900">
            Our Products
          </h1>

          <div className="w-24 h-1 bg-cyan-600 mx-auto mt-5 rounded-full"></div>

          <p className="mt-8 text-lg text-slate-600 max-w-3xl mx-auto leading-relaxed">
            We're building a powerful ecosystem of biometric attendance,
            visitor management, access control and smart security products
            for modern enterprises.
          </p>
        </div>

        {/* Main Coming Soon Card */}
        <div className="max-w-5xl mx-auto">

          <div className="bg-white/90 backdrop-blur-lg border border-slate-200 rounded-3xl shadow-2xl p-12 text-center">

            <div className="text-7xl mb-6 animate-bounce">
              🚀
            </div>

            <h2 className="text-4xl md:text-5xl font-bold text-slate-900">
              Products Coming Soon
            </h2>

            <p className="mt-6 text-slate-600 text-lg max-w-3xl mx-auto">
              Bytecs Technologies is preparing a complete range of
              enterprise-grade biometric and security solutions.
              Stay tuned for our upcoming product launch.
            </p>

            <div className="mt-10">
              <button className="bg-cyan-600 hover:bg-cyan-700 text-white px-8 py-4 rounded-xl font-semibold shadow-lg transition duration-300 hover:-translate-y-1">
                Notify Me
              </button>
            </div>

          </div>

        </div>

        {/* Product Preview Cards */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mt-20">

          <div className="bg-white p-8 rounded-2xl shadow-lg border border-slate-100 hover:shadow-cyan-100 transition duration-300 hover:-translate-y-2">
            <div className="text-5xl mb-4">👆</div>
            <h3 className="text-xl font-bold text-slate-900 mb-2">
              Biometric Devices
            </h3>
            <p className="text-slate-500 text-sm">
              Fingerprint and attendance management devices.
            </p>
          </div>

          <div className="bg-white p-8 rounded-2xl shadow-lg border border-slate-100 hover:shadow-cyan-100 transition duration-300 hover:-translate-y-2">
            <div className="text-5xl mb-4">😊</div>
            <h3 className="text-xl font-bold text-slate-900 mb-2">
              Face Recognition
            </h3>
            <p className="text-slate-500 text-sm">
              AI-powered facial authentication systems.
            </p>
          </div>

          <div className="bg-white p-8 rounded-2xl shadow-lg border border-slate-100 hover:shadow-cyan-100 transition duration-300 hover:-translate-y-2">
            <div className="text-5xl mb-4">🔐</div>
            <h3 className="text-xl font-bold text-slate-900 mb-2">
              Access Control
            </h3>
            <p className="text-slate-500 text-sm">
              Smart access control and door management solutions.
            </p>
          </div>

          <div className="bg-white p-8 rounded-2xl shadow-lg border border-slate-100 hover:shadow-cyan-100 transition duration-300 hover:-translate-y-2">
            <div className="text-5xl mb-4">📋</div>
            <h3 className="text-xl font-bold text-slate-900 mb-2">
              Visitor Management
            </h3>
            <p className="text-slate-500 text-sm">
              Digital visitor registration and tracking systems.
            </p>
          </div>

        </div>

        {/* Bottom CTA */}
        <div className="mt-24 text-center">

          <h3 className="text-3xl font-bold text-slate-900">
            Looking for a Custom Security Solution?
          </h3>

          <p className="mt-4 text-slate-600">
            Contact our experts today and discover how Bytecs can help
            automate and secure your business operations.
          </p>

          <a
            href="/contact"
            className="inline-block mt-8 bg-slate-900 hover:bg-black text-white px-8 py-4 rounded-xl font-semibold transition"
          >
            Contact Us
          </a>

        </div>

      </div>
    </section>
  );
};

export default Products;